import {makeStyles} from '@material-ui/core';
import {getDirectionStyles} from '../../../../../../utils/ThemeUtils';

const useStyles = makeStyles(theme => ({
    activationItem: {
        display: 'flex',
        borderBottom: '1px solid #0b0b0b',
        height: '58px',
        lineHeight: theme.typography.pxToRem(20),
        padding: getDirectionStyles(theme.direction)('19px 27px 18px 0', '19px 0 18px 27px'),
        position: 'relative',
        backgroundColor: theme.palette.background.overlays,

        [theme.breakpoints.up(1025)]: {
            position: 'static'
        },

        '& > div': {
            pointerEvents: 'none'
        },

        '&:hover': {
            backgroundColor: theme.palette.background.paper
        }
    },
    triggerName: {
        padding: getDirectionStyles(theme.direction)(
            theme.spacing(0, 8, 0, 5),
            theme.spacing(0, 5, 0, 8)
        ),
        width: 'calc(100% - 105px)',

        [theme.breakpoints.up('fsm')]: {
            width: 300,
            minWidth: 300,
            padding: getDirectionStyles(theme.direction)(
                theme.spacing(0, 10, 0, 5),
                theme.spacing(0, 5, 0, 10)
            )
        }
    },
    triggerNameEllipsis: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%'
    },
    triggerNameText: {
        [theme.breakpoints.up('flg')]: {
            marginTop: '-8px'
        }
    },
    triggerNameDescription: {
        display: 'none',
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,

        [theme.breakpoints.up('flg')]: {
            display: 'block',
            marginBottom: '-8px'
        }
    },
    activationData: {
        display: 'flex',

        '& .trend-container': {
            boxSizing: 'border-box',
            minWidth: 60,
            padding: getDirectionStyles(theme.direction)(
                theme.spacing(0, 2, 0, 0),
                theme.spacing(0, 0, 0, 2)
            ),
            whiteSpace: 'nowrap',
            marginLeft: 0
        },

        '& .MuiSvgIcon-root': {
            transform: 'scale(1.4)'
        },

        [theme.breakpoints.up('fsm')]: {
            margin: getDirectionStyles(theme.direction)(
                theme.spacing(0, 7, 0, 0),
                theme.spacing(0, 0, 0, 7)
            )
        },

        [theme.breakpoints.up('fmd')]: {
            margin: getDirectionStyles(theme.direction)(
                theme.spacing(0, 12, 0, 0),
                theme.spacing(0, 0, 0, 12)
            )
        },

        [theme.breakpoints.up('flg')]: {
            margin: getDirectionStyles(theme.direction)(
                theme.spacing(0, 18, 0, 0),
                theme.spacing(0, 0, 0, 18)
            )
        }
    },
    activationsNumber: {
        boxSizing: 'border-box',
        minWidth: 40,
        padding: getDirectionStyles(theme.direction)(
            theme.spacing(0, 1, 0, 0),
            theme.spacing(0, 0, 0, 1)
        ),

        [theme.breakpoints.up('fsm')]: {
            margin: getDirectionStyles(theme.direction)(
                theme.spacing(0, 7, 0, 0),
                theme.spacing(0, 0, 0, 7)
            )
        },

        [theme.breakpoints.up('fmd')]: {
            margin: 0
        }
    },
    activationsBar: {
        flexGrow: 1,

        [theme.breakpoints.up('xs')]: {
            display: 'none'
        },

        [theme.breakpoints.up('fsm')]: {
            display: 'block'
        },

        [theme.breakpoints.up('fmd')]: {
            padding: getDirectionStyles(theme.direction)(
                theme.spacing(0, 11, 0, 0),
                theme.spacing(0, 0, 0, 11)
            )
        }
    },
    activationsColorMarker: {
        paddingTop: 4,

        [theme.breakpoints.up('xs')]: {
            display: 'none'
        },

        [theme.breakpoints.up('fmd')]: {
            display: 'block'
        }
    }
}));

export default useStyles;
